<template>
  <modal-layout id="reorder-layer1" addClass="layer_section_renew type-b">
    <popup-reorder-request
      :purchase-type="purchaseType"
      :req-no="reqNo"
      :mypack-name="mypackName"
      :isOrderPayment="isOrderPayment"
      @dispose="onDispose"
    />
  </modal-layout>
</template>
<script>
import ModalLayout from "@/components/global/ModalLayout.vue";
import modalMixin from "@/components/global/modal-mixin";
import PopupReorderRequest from "./PopupReorderRequest.vue";

export default {
  name: "ModalReorderRequest",
  components: {
    ModalLayout,
    PopupReorderRequest,
  },
  mixins: [modalMixin],
  props: {
    purchaseType: {
      type: String,
      default: "single",
    },
    reqNo: {
      type: Number,
      default: 0,
    },
    mypackName: {
      type: String,
      default: "",
    },
    isOrderPayment: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style>
</style>
